import _ from 'underscore';

import { DataTable } from '@tableau/metrics-engine';
import { ConnectedViewContextType } from '../../ts/ServerApi/types/IMetric';
import { IMetricDataPointsSchema } from '../../ts/ServerApi/types/IMetricDataList';
import { IMetricUsageInfo } from '../../ts/ServerApi/types/IUsageInfo';
import { ICreatedItemInfo, IDescriptionItemInfo, IExplorableItemTypeInfo, IFavoriteItem, IIdItemInfo, INamedItemInfo, IOwnedItemInfo, IProjectItemInfo, ISuspendedItem, ITaggedItemInfo, IUpdatedItemInfo, ILuidItemInfo, ILocationItemInfo } from '../../ts/models/resourceInfoParts';

export interface IMetricInfo extends
    IExplorableItemTypeInfo<'metric'>,
    INamedItemInfo,
    IIdItemInfo,
    IUpdatedItemInfo,
    ICreatedItemInfo,
    IFavoriteItem,
    IDescriptionItemInfo,
    ITaggedItemInfo,
    IProjectItemInfo,
    ILocationItemInfo,
    IMetricDataInfo,
    IOwnedItemInfo,
    Partial<ISuspendedItem>,
    ILuidItemInfo
{
  connectedView: IConnectedViewInfo;
  usageInfo?: IMetricUsageInfo;
  usageInfoMaxValues?: IMetricUsageInfo;
}

export type IMetricInfoWithoutData = Omit<IMetricInfo, keyof IMetricDataInfo>;

export interface IMetricDataInfo {
  dataPoints?: DataTable;
  schema?: IMetricDataPointsSchema;
  dataRefreshedTimestamp?: string;
}

export interface IConnectedViewInfo extends INamedItemInfo {
  viewId: string;
  isViewModified: boolean;
  path: string;
  thumbnailUrl: string;
  type: ConnectedViewContextType;
}

export function isMetricInfo(metric: IExplorableItemTypeInfo): metric is IMetricInfo {
  return (metric.contentType === 'metric');
}
